export default {"src":"/_next/static/media/icon_avatar_add.73a3a686.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};